module.exports = __webpack_public_path__ + "static/media/code2x.27200f68.png";


//////////////////
// WEBPACK FOOTER
// ./src/node_modules/kts-platform-frame/appSdk/AppResource/WarningContent/img/code2x.png
// module id = 2450
// module chunks = 0